document.addEventListener('DOMContentLoaded', function() {
  initRoyalMobileNavbar();
  setAdjustedVh();
});

function setAdjustedVh() {
  const docEl = document.documentElement;
  const vv = window.visualViewport;

  let height;

  if (vv) {
    const ua = navigator.userAgent;
    const isIOS = /iP(hone|ad|od)/.test(ua);
    const isChromeIOS = /CriOS/.test(ua);

    if (isIOS) {
      if (isChromeIOS) {
        // ✅ iOS Chrome: use window.innerHeight to avoid bottom white gap
        height = window.innerHeight;
      } else {
        // iOS Safari: normalize with offsetTop
        const candidate = vv.height + vv.offsetTop;
        height = Math.min(candidate, window.innerHeight);
      }
    } else {
      // Android / desktop
      height = vv.height;
    }
  } else {
    height = window.innerHeight;
  }

  const vh = height * 0.01;

  // Calculate nav offset
  const isolate = document.querySelector('.section-mobile-navigation .isolate');
  const offset = isolate ? isolate.getBoundingClientRect().height : 0;

  // iOS safe-area inset
  const safeInset = parseInt(getComputedStyle(docEl).getPropertyValue("env(safe-area-inset-bottom)") || 0, 10) || 0;

  docEl.style.setProperty('--vh', `${vh}px`);
  docEl.style.setProperty('--nav-offset', `${offset + safeInset}px`);
}

// Listen for viewport changes
window.visualViewport?.addEventListener('resize', setAdjustedVh, { passive: true });
window.visualViewport?.addEventListener('scroll', setAdjustedVh, { passive: true });
window.addEventListener('resize', setAdjustedVh, { passive: true });
window.addEventListener('orientationchange', setAdjustedVh);

function initRoyalMobileNavbar() {
  const tier1Items = document.querySelectorAll('.royal-tier-1-item');
  const menuPanels = document.querySelectorAll('.royal-menu-panel');
  const menuToggle = document.querySelector('.nav-center');
  const body = document.body;
  
  if (tier1Items.length === 0 || menuPanels.length === 0) return;
  
  // Initialize first panel as active on page load
  if (tier1Items.length > 0 && menuPanels.length > 0) {
    tier1Items[0].classList.add('active');
    menuPanels[0].classList.add('active');
  }
  
  // Handle menu toggle - matching REF behavior
  if (menuToggle) {
    menuToggle.addEventListener('click', function(e) {
      e.preventDefault();
      const isActive = document.body.classList.contains('mobilemenuIsactive');
      document.body.classList.toggle('mobilemenuIsactive');

      // If menu is being closed, reset all open states
      if (isActive) {
        // Reset tier 1 active items
        tier1Items.forEach(item => item.classList.remove('active'));
        menuPanels.forEach(panel => panel.classList.remove('active'));
        
        // Set first item as active if it exists
        if (tier1Items.length > 0) {
          tier1Items[0].classList.add('active');
          if (menuPanels.length > 0) {
            menuPanels[0].classList.add('active');
          }
        }
      } else {
        // Smooth scroll to top when opening menu
        setTimeout(() => {
          const activePanel = document.querySelector('.royal-menu-panel.active');
          if (activePanel) {
            activePanel.scrollTop = 0;
          }
        }, 100);
      }
    });
  }
  
  // Function to close menu and reset state
  function closeMobileMenu() {
    body.classList.remove('mobilemenuIsactive');
    
    // Reset to first tab after transition ends (300ms)
    setTimeout(() => {
      if (!body.classList.contains('mobilemenuIsactive')) {
        tier1Items.forEach(item => item.classList.remove('active'));
        menuPanels.forEach(panel => panel.classList.remove('active'));
        if (tier1Items.length > 0) {
          tier1Items[0].classList.add('active');
          if (menuPanels.length > 0) {
            menuPanels[0].classList.add('active');
          }
        }
      }
    }, 300);
  }

  // Close menu when clicking overlay or outside content
  document.addEventListener('click', function(e) {
    if (body.classList.contains('mobilemenuIsactive') && 
        !e.target.closest('.menu-wrapper') && 
        !e.target.closest('.nav-center')) {
      closeMobileMenu();
    }
  });

  // Handle close button click
  const closeBtn = document.querySelector('.royal-close-drawer');
  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.preventDefault();
      closeMobileMenu();
    });
  }

  // Handle swipe down to close
  const menuWrapper = document.querySelector('.menu-wrapper');
  let startY = 0;
  let currentY = 0;
  let startScrollTop = 0;
  
  if (menuWrapper) {
    menuWrapper.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
      currentY = startY;
      const activePanel = document.querySelector('.royal-menu-panel.active');
      startScrollTop = activePanel ? activePanel.scrollTop : 0;
    }, { passive: true });

    menuWrapper.addEventListener('touchmove', function(e) {
      currentY = e.touches[0].clientY;
    }, { passive: true });

    menuWrapper.addEventListener('touchend', function(e) {
      const diffY = currentY - startY;
      
      // Swipe down threshold: > 200px (requires a longer pull to avoid accidental closes)
      // Only close if we started draging when we were already securely at the top
      if (diffY > 200 && startScrollTop <= 5) {
        closeMobileMenu();
      }
    }, { passive: true });
  }
  
  // Handle tier 1 menu item clicks
  tier1Items.forEach(item => {
    item.addEventListener('click', function() {
      const targetIndex = this.getAttribute('data-menu-index');
      
      // Remove active class from all items and panels
      tier1Items.forEach(i => i.classList.remove('active'));
      menuPanels.forEach(p => p.classList.remove('active'));
      
      // Add active class to clicked item and corresponding panel
      this.classList.add('active');
      const targetPanel = document.querySelector(`.royal-menu-panel[data-panel-index="${targetIndex}"]`);
      if (targetPanel) {
        targetPanel.classList.add('active');
        
        // Smooth scroll to top of the panel
        targetPanel.scrollTop = 0;
      }
    });
  });
  
  // Removed swipe logic to prevent accidental clicking while scrolling horizontally
  
  // Handle keyboard navigation
  document.addEventListener('keydown', function(e) {
    if (e.target.closest('.royal-mobile-menu')) {
      const activeItem = document.querySelector('.royal-tier-1-item.active');
      if (activeItem) {
        const currentIndex = parseInt(activeItem.getAttribute('data-menu-index'));
        let newIndex;
        
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          newIndex = currentIndex === 0 ? tier1Items.length - 1 : currentIndex - 1;
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          newIndex = (currentIndex + 1) % tier1Items.length;
        } else {
          return;
        }
        
        const newItem = document.querySelector(`.royal-tier-1-item[data-menu-index="${newIndex}"]`);
        if (newItem) {
          newItem.click();
          newItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }
    }
  });
  
  // Handle menu initialization when menu is opened
  if (menuToggle) {
    menuToggle.addEventListener('click', function() {
      // Small delay to ensure menu is visible
      setTimeout(() => {
        // Scroll active item into view if needed
        const activeItem = document.querySelector('.royal-tier-1-item.active');
        if (activeItem) {
          activeItem.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        }
      }, 100);
    });
  }
}

// Re-initialize when Shopify section is loaded in theme editor
document.addEventListener('shopify:section:load', function() {
  initRoyalMobileNavbar();
});
